import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { API_URL } from 'src/app/shared/constants/apiurl-constants';
import { role } from 'src/app/shared/constants/role-enum';
import { BaseResponse } from '../../shared/models/base-response.model';
import { environment } from 'src/environments/environment';
import { isRcnSurveyApplication } from 'src/app/shared/lib/custom-tools';
import {
    UserRolesPermissionResponse
} from '../models/user-roles-permission.model';
import { ImpersonationService } from '../../shared/impersonation/impersonation.service';
import { LoggedInUserService } from '../../shared/logged-in-user/logged-in-user.service';
import { map } from 'rxjs/operators';
import { UserDetails } from '../models/user-details.model';
import { getInitials } from '../../shared/lib/get-intitials';
const ZERO = 0;

@Injectable({ providedIn: 'root' })
export class UserDataService {
    // Provides the current user context.  If Client Manager View or SME View are active, provides a modified
    // user context of the impersonated user.  Otherwise, provides details of the logged-in user.
    userDetails$: Observable<UserDetails> = combineLatest([
        this.loggedInUserService.loggedInUser$,
        this.impersonationService.clientManagerModeActive$,
        this.impersonationService.smeUserDetails$,
    ]).pipe(
        map(([loggedInUser, clientManagerModeActive, smeUserDetails]) => {
            const canActivateImpersonation = {
                [role.none]: false,
                [role.admin]: true,
                [role.clientManager]: false,
                [role.clientAdmin]: false,
                [role.champion]: true,
            };

            if (canActivateImpersonation[loggedInUser.roleId] && (clientManagerModeActive)) {
                // if user is allowed to impersonate a client manager, and the mode is active
                // return a user context object as the logged-in user with role equal to clientManager
                return {
                    ...loggedInUser,
                    roleId: role.clientManager
                }
            } else if (canActivateImpersonation[loggedInUser.roleId] && !!(smeUserDetails)) {
                // if user is allowed to impersonate a client SME, and the mode is active
                // return a user context object as the impersonated user with role equal to surveyRespondent
                return {
                    ...smeUserDetails,
                    userNameInitials: getInitials(smeUserDetails.firstName, smeUserDetails.lastName),
                    roleId: role.respondent,
                }
            } else {
                return loggedInUser
            }

        }),
    );


    constructor(
        private _httpClient: HttpClient,
        private impersonationService: ImpersonationService,
        private loggedInUserService: LoggedInUserService,
    ) { }

    getLandingPageBasedOnRole(roleId: number): string {
        if (!roleId || roleId === ZERO) {
            return '';
        }
        else if (isRcnSurveyApplication()) {
            return '/surveys';
        }
        else {
            switch (roleId) {
                case role.admin:
                case role.champion:
                case role.clientAdmin:
                    return '/home';
                    break;
                case role.clientManager:
                    // return '/studies';
                    // return '/survey-app';
                    if (!environment.production) {
                        location.assign(environment.rcnSurveyUrl);
                    }
                    else {
                        let envName = `${environment.envName}`;
                        // location.assign(`${environment.rcnInternalSurvey}`)
                        console.log('environment:' + envName);
                        const isQAAdHocEnv = envName.trim().length > 1 ? true : false;
                        if (isQAAdHocEnv) {
                            // location.assign(`${environment.rcnInternalSurvey}${envName.substring(1)}`);
                            window.location.assign(`${environment.rcnUrl}rcnsurvey${envName.substring(1)}`);
                        } else {
                            // location.assign(`${environment.rcnInternalSurvey}${envName}`)
                            window.location.assign(`${environment.rcnUrl}rcnsurvey${envName}`);
                        }
                    }

                    break;
                case role.respondent:
                    return '/survey-app';
                    break;
                default:
                    return '/page-not-found';
            }
        }
    }

    getUserRolesAndPermissions(): Observable<UserRolesPermissionResponse> {
        // this dummy api Ping call is required as first api call to resolve some issue from Azure
        this._httpClient.post(environment.webApiDefaultRoot + API_URL.PING, null).subscribe(() => { });
        return this._httpClient.get<UserRolesPermissionResponse>(environment.webApiDefaultRoot + API_URL.GETPERMISSIONS);
    }

    isSuperAdmin() {
        return this._httpClient.get<BaseResponse>(environment.webApiDefaultRoot + API_URL.IS_SUPER_ADMIN);
    }

    updateFirstLoginDateTime() {
        this._httpClient.post(environment.webApiDefaultRoot + API_URL.UPDATEFIRSTLOGINDATETIME, {}).subscribe(() => { });
    }

}
